import React, { Component } from 'react';


const RadioButtonBonificacionRenovacionColumn = (props) => {
    
    return (
        <div className="col-md-3">
            <div className="container-radio radio-margin">
                <input name="bonif"
                    id={"bonif" + props.Id}
                    value={props.Id}
                    type="radio"
                    onClick={(event) => props.changeRadio("BONIFICACION", event.target.value)}
                    checked={props.checked} />
                <label className="lbl-radio label-secondary"
                    htmlFor={"bonif" + props.Id}>
                    {props.PorcentajeBonificacion + " %"}
                </label>
            </div>
        </div>
    );
}

export default RadioButtonBonificacionRenovacionColumn;